<template>
  <div
    v-if="operator != null && operator !== false"
    :data-formula-operator="isPreset ? (operator as string) : 'custom'"
    :style="containerStyle"
  >
    <component v-if="IconComp" :is="IconComp" :style="{ width: '100%', height: '100%' }" />
    <template v-else>
      <slot>{{ operator }}</slot>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, type CSSProperties, type Component } from 'vue'
import { AlgoDivide, AlgoEq, AlgoMinus, AlgoMultiply, AlgoPlus } from '@jd/jdesign-icons-vue'
import { useNamespace } from '@jdesign-vue/hooks'
import type { StatisticCardOperator, StatisticCardSize, StatisticVNode } from '../types'
import { createColorVars } from '../constants'

const OPERATOR_ICON_MAP: Record<StatisticCardOperator, Component> = {
  eq: AlgoEq,
  plus: AlgoPlus,
  minus: AlgoMinus,
  multiply: AlgoMultiply,
  divide: AlgoDivide,
}

const props = withDefaults(defineProps<{
  operator?: StatisticCardOperator | StatisticVNode
  size?: StatisticCardSize
}>(), {
  size: 'large',
})

const ns = useNamespace('statistic-card')
const colorVars = createColorVars(ns.cssVarName)

const isPreset = computed(() => typeof props.operator === 'string' && props.operator in OPERATOR_ICON_MAP)
const IconComp = computed(() => isPreset.value ? OPERATOR_ICON_MAP[props.operator as StatisticCardOperator] : undefined)
const iconSize = computed(() => props.size === 'large' ? 18 : 16)

const containerStyle = computed<CSSProperties>(() => ({
  minWidth: `${iconSize.value}px`,
  alignSelf: 'center',
  color: colorVars.textLabel,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: `${iconSize.value}px`,
  lineHeight: '1',
  ...(IconComp.value ? { width: `${iconSize.value}px`, height: `${iconSize.value}px` } : {}),
}))
</script>
